module.exports = __webpack_public_path__ + "static/img/vi.20039586.svg";